import React from 'react';
import styled from 'styled-components';
import logo from "./images/logo2.png"
import {Button} from "./styles/Button";
import { NavLink } from 'react-router-dom';

const Login = () => {

    const Wrapper = styled.section`
    
    .main_div{
        height: 100vh;
        width: 100vw;
        background-color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

    }

    .child_div{
        height: 70vh;
        width: 40vw;
        background-color: rgb(249 249 255);
        display: flex;
        
        flex-direction: column;
        justify-content: center;
        align-items: center;

    }

    input{
      width: 25rem;
      margin: 2.5rem 3.5rem;
      border: 0.3px solid rgb(255, 255, 255);
      border-radius: 0.4rem;
    }
    `;
  return (
    <Wrapper>
        <div className='main_div'>
            <div className='child_div'>
                <NavLink to ="/" >
                   <img src={logo} alt = 'logo' className='logo'/>
                 </NavLink>
                 <input type="text" placeholder="Enter Roll No" />
                 <input type="password" placeholder="Enter your password" />
                 <Button>Login</Button>
                 <p>Don't have an account? <NavLink to="/register">Register</NavLink></p>
            </div>
        </div>
    </Wrapper>
  )
}

export default Login